export const USER_INFO = 'USER_INFO';
export const STORE_ACCOUNT = 'STORE_ACCOUNT';
export const CUR_ROLE = 'CUR_ROLE';
export const ROLE_LIST = 'ROLE_LIST';
export const CUR_TENANT = 'CUR_TENANT';
export const serviceAgreement = 'https://permuat.midea.com/agreement/?policy=Login&code=jx4ikhqesgytjjaf&appId=100123';
export const privacyAgreement = 'https://permuat.midea.com/agreement/?policy=Login&code=6n9m0hs5yn26v817&appId=100123';
export const secrect =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCUe2LI5aUIrSEV47qyYHdXquFJ2hvSOpaqZpEMaH+uv9x3CW7Mn/6Sek0njIYIwI9srE/pfHQwolWbYiRd7rEi0azfUPTqwuyh79ye5Lho9j9hhY212PcdRrHXaoTVqSO2uG4LgJawVUII6mlUbBHDZ4P3+5CSwwDskrQBY6rrkQIDAQAB';
export const appId = 'b311727d4689ce8f6a67cb652227a17c'; // 顶象appid
export const appSecret = '92eacc7b05d5d11068016b7f39944e4b'; // 顶象appSecret

// 中国移动：134、135、136、137、138、139、147、150、151、152、157、158、159、178、182、183、184、187、188、198。
// 中国联通：130、131、132、145、155、156、166、175、176、185、186。
// 中国电信：133、149、153、173、177、180、181、189、199。
// 虚拟运营商：170、171、172、174、198。
export const phoneRegex =
  /^(134|135|136|137|138|139|147|150|151|152|157|158|159|178|182|183|184|187|188|198|130|131|132|145|155|156|166|175|176|185|186|133|149|153|173|177|180|181|189|199|170|171|172|174|198)\d{8}$/;
